const RootPath = window.g.baseUrl
const apis = {
  /* 入库 api */
  // 获取入库列表
  getInstoreList: RootPath + 'plugin/store/instore/GetInstoreList',
  // 删除入库列表
  delInstoreList: RootPath + 'plugin/store/instore/DelInstoreList',
  // 获取产品数据
  getInstoreProduct: RootPath + 'plugin/store/instore/GetInstoreProduct',
  // 获取入库表单
  getInstoreForm: RootPath + 'plugin/store/instore/GetInstoreForm',
  // 保存入库
  saveInstore: RootPath + 'plugin/store/instore/SaveInstore',
  // 物料
  getInstoreProductParts: RootPath + 'plugin/store/instore/GetInstoreProductParts',

  /* 出库 api */
  getOutsourceOutstoreList: RootPath + 'plugin/store/outstore/GetOutsourceOutstoreList',
  getOutSourceOutStoreForm: RootPath + 'plugin/store/outstore/GetOutSourceOutStoreForm',
  getOutStoreStoreDetail: RootPath + 'plugin/store/outstore/GetOutStoreStoreDetail',
  getOutSideStoreDetail: RootPath + 'plugin/store/outstore/GetOutSideStoreDetail',
  saveOutstore: RootPath + 'plugin/store/outstore/SaveOutstore',
  getOutstoreList: RootPath + 'plugin/store/outstore/GetOutstoreList',
  getOutStoreForm: RootPath + 'plugin/store/outstore/GetOutStoreForm',
  delOutstoreList: RootPath + 'plugin/store/outstore/DelOutstoreList',

  /* 半成品入库 api */
  getHalfProductInstoreList: RootPath + 'plugin/store/halfproductinstore/GetHalfProductInstoreList',
  delHalfProductInstoreList: RootPath + 'plugin/store/halfproductinstore/DelHalfProductInstoreList',
  getHalfProsuctInstoreForm: RootPath + 'plugin/store/halfproductinstore/GetHalfProsuctInstoreForm',
  saveHalfProductInstore: RootPath + 'plugin/store/halfproductinstore/SaveHalfProductInstore',
  getDeliveryStoreDetail: RootPath + 'plugin/store/halfproductinstore/GetDeliveryStoreDetail',

  /* 半成品出库 api */
  getHalfProductOutstoreList: RootPath + 'plugin/store/halfproductoutstore/GetHalfProductOutstoreList',
  getHalfProductOutstoreForm: RootPath + 'plugin/store/halfproductoutstore/GetHalfProductOutstoreForm',
  getHalfProductOutstoreDetail: RootPath + 'plugin/store/halfproductoutstore/GetHalfProductOutstoreDetail',
  saveHalfProductOutstore: RootPath + 'plugin/store/halfproductoutstore/SaveHalfProductOutstore',
  delHalfProductOutstoreList: RootPath + 'plugin/store/halfproductoutstore/DelHalfProductOutstoreList',
  checkWhetherOutStore: RootPath + 'plugin/store/halfproductoutstore/CheckWhetherOutStore',

  /* 半成品出库 api */
  getStoresData: RootPath + 'plugin/store/change/GetStoresData',
  getChangeData: RootPath + 'plugin/store/change/GetChangeData',
  saveChangeData: RootPath + 'plugin/store/change/SaveChangeData',
  delChangeData: RootPath + 'plugin/store/change/DelChangeData',

  /* 不良品出库 api */
  saveOutreject: RootPath + 'plugin/store/outstore/SaveOutreject',
  delOutrejectList: RootPath + 'plugin/store/outstore/DelOutrejectList',

  /* 不良品入库 api */
  saveInreject: RootPath + 'plugin/store/instore/SaveInreject',
  delInrejectList: RootPath + 'plugin/store/instore/DelInrejectList',

    /* 台纸管理中报表（趋势图、echart） api */
  getMonthBillByTypeAndYear: RootPath + 'plugin/store/report/GetMonthBillByTypeAndYear'
}

export default apis
